import Analytcs from './analytcs'
import Inicio from "pages/Inicio";
import NaoEncontrada from "pages/NaoEncontrada";
import Noticias from "pages/Noticias";
import PaginaBase from "pages/PaginaBase";
import Legislacao from "pages/Legislacao";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Contato from "pages/Contatos";
import Login from "pages/Login/Login";
import NovoCadastro from "pages/Login/NovoCadastro";
import TrocarSenha from "pages/Login/TrocarSenha";
import Questionario from 'pages/Admin/QuestionarioAdmin'
import BoasPraticas from "pages/BoasPraticas"
import ProgramaProVida from 'pages/BoasPraticas/programaProVida'
import AviagemdeLucy from "pages/BoasPraticas/aViagemdeLucy";
import ServicodeAbordagem from "pages/BoasPraticas/servicodeAbordagem";
import Funcef from "pages/BoasPraticas/funcef";
import ProgramadeResistencia from "pages/BoasPraticas/programaderesistencia";
import LerNoticia from "components/Noticias/LerNoticia";
import Principal from "pages/Admin/Inicio";
import Usuarios from "pages/Admin/Usuarios";
import MapaFronteira from 'pages/Mapa/MapaFronteira';
import MapaCrack from 'pages/Mapa/MapaCrack'
import Biblioteca from "pages/Biblioteca";
import MapaAssistencia from 'pages/Mapa/MapaAssistencia'
import Mapas from 'components/Opcoes/Mapas'
import EmConstrucao from "pages/EmConstrucao"
import Relatorios from "pages/Admin/Relatorios"
import PesquisaUsuarios from "pages/Admin/PesquisaUsuarios"
// import Logout from 'pages/Login/Logout';
import AdminLayout from 'pages/Admin/';
import Solicitacoes from 'pages/Admin/Usuarios/Solicitações'
import VisualizarRespostas from 'pages/Admin/PesquisaUsuarios/VisualizarResposta';
import UserProfile from 'pages/Admin/Inicio/UserProfile';
import ProtectedRoute from 'ProtectedRoute';


function AppRoutes() {
	const token = localStorage.getItem('token')
	return (
		<BrowserRouter>
			<Analytcs />
			<Routes>
				<Route path="login" element={<Login />} />
				<Route path="trocar-senha" element={<TrocarSenha />} />
				<Route path="cadastro" element={<NovoCadastro />} />
				{/* <Route path="logout" element={<Logout />} /> */}

				<Route path="/admin/*" element={
					<ProtectedRoute token={token}>
						<AdminLayout />
					</ProtectedRoute> 
				}>
						<Route path="principal" element={<Principal />} />
						 <Route path="pesquisa" element={<PesquisaUsuarios />}></Route>
						 <Route path="questionario" element={<Questionario />} />
						<Route path="usuarios" element={<Usuarios />} />
						<Route path="relatorios" element={<Relatorios />} />
						<Route path="solicitacoes" element={<Solicitacoes />}></Route>
						<Route path="visualizar-respostas" element={<VisualizarRespostas />}> </Route>
						<Route path="perfil" element={<UserProfile/>}></Route>
					</Route>
				{/* } */}

				<Route path="/" element={<PaginaBase />}>
					<Route path="*" element={<NaoEncontrada />} />
					<Route path="/cartilhas" element={<EmConstrucao />} />
					<Route path="/estudos" element={<EmConstrucao />} />
					<Route index element={<Inicio />} />
					<Route path="noticias" element={<Noticias />} />
					<Route path="/noticia/:noticiaId" element={<LerNoticia />} />
					<Route path="legislacao" element={<Legislacao />} />
					<Route path="contato" element={<Contato />} />
					<Route path="biblioteca" element={<Biblioteca />} />
					<Route path="boas-praticas" element={<BoasPraticas />}></Route>
					<Route path="programa-pro-vida" element={<ProgramaProVida />}></Route>
					<Route path="a-viagem-de-lucy" element={<AviagemdeLucy />}></Route>
					<Route path="servico-de-abordagem-social-multidisciplinar" element={<ServicodeAbordagem />}></Route>
					<Route path="funcef" element={<Funcef />}> </Route>
					<Route path="programa-resistencia-drogas" element={<ProgramadeResistencia />}></Route>
					<Route path="mapa-assistencia" element={<MapaAssistencia />} />
					<Route path="mapa-fronteiras" element={<MapaFronteira />}></Route>
					<Route path="mapa-crack" element={<MapaCrack />}></Route>
					<Route path="mapas" element={<Mapas />} ></Route>
					<Route path="contatos" element={<Contato />}></Route>

				</Route>
			</Routes>
		</BrowserRouter>

	)
}

export default AppRoutes;
